<template>
  <div>
    <div class="form-group">
      <div class="checkbox styled">
        <input id="conditional" v-model="conditional" type="checkbox" />
        <label for="conditional">
          {{ lang.get('fields.form.conditional.label') }}
        </label>
      </div>
    </div>
    <template v-if="conditional">
      <div class="form-group">
        <select v-model="conditionalVisibility" class="form-control">
          <option value="hide">
            {{ lang.get('fields.form.conditional.visibility.hide') }}
          </option>
          <option value="show">
            {{ lang.get('fields.form.conditional.visibility.show') }}
          </option>
        </select>
      </div>
      <div class="form-group">
        {{ lang.get('fields.form.conditional.when') }}
      </div>
      <div class="form-group">
        <select v-model="conditionalFieldId" class="form-control">
          <option
            v-for="field in fieldList"
            :key="'field-' + field.id"
            :value="field.id"
          >
            {{ field.title }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <select v-model="conditionalPattern" class="form-control">
          <option
            v-for="pattern in conditionalPatterns"
            :key="pattern.key"
            :value="pattern.id"
            :disabled="pattern.disabled"
          >
            {{ pattern.name }}
          </option>
        </select>
      </div>
      <div v-if="conditionalValueVisible" class="form-group">
        <input v-model="conditionalValue" type="text" class="form-control" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inject: ['lang'],
  props: {
    field: {
      type: Object,
      required: true
    },
    conditionalFields: {
      type: Array,
      required: true
    },
    conditionals: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      conditional: this.field.conditional,
      conditionalFieldId: this.field.conditionalFieldId,
      conditionalPattern: this.field.conditionalPattern,
      conditionalValue: this.field.conditionalValue,
      conditionalVisibility: this.field.conditionalVisibility
    };
  },
  computed: {
    selectedField() {
      return this.conditionalFields.find(
        field => field.id === this.conditionalFieldId
      );
    },
    conditionalValueVisible() {
      return ![
        'empty',
        'is not empty',
        'is checked',
        'is not checked'
      ].includes(this.conditionalPattern);
    },
    properties() {
      return [
        this.conditional,
        this.conditionalFieldId,
        this.conditionalPattern,
        this.conditionalValue,
        this.conditionalVisibility
      ];
    },
    fieldList() {
      return this.conditionalFields.map(field => ({
        id: field.id,
        title: field.title
      }));
    },
    conditionalPatterns() {
      return Object.keys(this.conditionals).map(key => {
        const conditional = this.conditionals[key];

        const disabled =
          this.selectedField &&
          ((!['numeric', 'currency'].includes(this.selectedField.type) &&
            (conditional === 'is greater than' ||
              conditional === 'is less than')) ||
            (this.selectedField.type !== 'checkbox' &&
              (conditional === 'is checked' ||
                conditional === 'is not checked')));

        return {
          id: conditional,
          key: key,
          name: this.lang.get(`fields.form.conditional.options.${key}`),
          disabled: disabled || false
        };
      });
    }
  },
  watch: {
    properties() {
      this.$emit('input', {
        conditional: this.conditional,
        conditionalFieldId:
          this.conditional && this.selectedField ? this.selectedField.id : null,
        conditionalFieldSlug:
          this.conditional && this.selectedField
            ? this.selectedField.slug
            : null,
        conditionalPattern: this.conditional ? this.conditionalPattern : null,
        conditionalValue: this.conditional ? this.conditionalValue : null,
        conditionalVisibility: this.conditional
          ? this.conditionalVisibility
          : null
      });
    },
    conditionalFieldId() {
      // The available patters depend on the field type, therefore it's necessary
      // to reset the pattern selection each time a field is selected.
      this.conditionalPattern = null;
    }
  }
};
</script>
